import axios from "axios";

import { isSSR } from "../utils/helpers/isSSR";

export let $api;
if (isSSR()) {
  $api = axios.create({
    baseURL: process.env.REACT_APP_SSR_API_URL
  });
} else {
  $api = axios.create();

  $api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error?.response?.status === 401) {
        window.localStorage.removeItem("user");
        return Promise.reject(error);
      } else if (
        error?.message === "Request aborted" ||
        error?.code === "ECONNABORTED" ||
        axios.isCancel(error)
      ) {
        console.warn("Axios: Request aborted");
        return Promise.resolve(null);
      } else {
        return Promise.reject(error);
      }
    }
  );
}
